/*
 * Cursor-tracking for the animated glow lines (snippets/animated-glow-lines.liquid).
 *
 * Global + idempotent on purpose: one set of window listeners updates every
 * `.glow-lines` element currently in the DOM by writing the --glow-x/--glow-y
 * custom properties. Querying on each frame means it also covers grids that are
 * injected after load (e.g. product-recommendations swaps its innerHTML in), for
 * which an inline per-instance <script> would never run.
 */
(function () {
  if (window.__animatedGlowLinesInit) return;
  window.__animatedGlowLinesInit = true;

  var mouseX = null;
  var mouseY = null;
  var raf = null;

  function apply() {
    raf = null;
    if (mouseX === null) return;
    var els = document.getElementsByClassName('glow-lines');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) continue;
      el.style.setProperty('--glow-x', ((mouseX - r.left) / r.width * 100).toFixed(1) + '%');
      el.style.setProperty('--glow-y', ((mouseY - r.top) / r.height * 100).toFixed(1) + '%');
    }
  }

  function schedule() {
    if (raf === null) raf = requestAnimationFrame(apply);
  }

  function track(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  }

  window.addEventListener('mousemove', function (e) { track(e); schedule(); });
  window.addEventListener('wheel', function (e) { track(e); }, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
})();
